import { render, staticRenderFns } from "./WorkShiftForm.vue?vue&type=template&id=0acd0a0c&"
import script from "./WorkShiftForm.vue?vue&type=script&lang=js&"
export * from "./WorkShiftForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports